import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { ObjectiveRoutingModule } from './objective-routing.module';
import { ObjectiveListComponent } from './objective-list/objective-list.component';
import { ObjectiveCreateComponent } from './objective-create/objective-create.component';

@NgModule({
  declarations: [ObjectiveListComponent, ObjectiveCreateComponent],
  imports: [
    CommonModule,
    ObjectiveRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class ObjectiveModule { }
